export default {
  namespaced: true,
  state: {
    filter: '',
    expanded: [],
    parents: [],
    routes: [],
  },

  getters: {
    expanded: ({ filter, expanded }) => name => filter !== '' ? true : expanded.includes(name),
    allExpanded: state => state.expanded.length === state.parents.length,
    allClosed: state => state.expanded.length === 0,
    search: ({ filter }) => label => label.toLowerCase().includes(filter.toLowerCase()),
    visibleRoutes: ({ routes }, getters, rootState, rootGetters) => routes.filter(({ hideLocales }) => !hideLocales || !hideLocales.includes(rootGetters['auth/locale'])),
  },

  actions: {
    init({ commit, dispatch }, { routes, iconFromParent }) {
      for (const { name, children = [], meta: { bc: { label, icon }, hide, hideLocales } } of routes) {
        if (children.length > 0) {
          commit('saveParent', name)
          dispatch('init', { routes: children, iconFromParent: icon || iconFromParent })
        } else if (!hide) commit('saveRoute', { value: name, label, iconFromParent, hideLocales })
      }
    },
    expandMatched({ commit, state }, [...matched]) {
      for (const name of state.expanded) !matched.includes(name) && commit('collapse', name)

      for (const name of matched) commit('expand', name)
    },
    updateExpanded({ commit }, { name, val }) {
      commit(val ? 'expand' : 'collapse', name)
    },
    expandAll({ state, commit }) {
      for (const name of state.parents) commit('expand', name)
    },
    closeAll({ state, commit }) {
      for (const name of state.expanded) commit('collapse', name)
    },
  },

  mutations: {
    expand(state, name) {
      !state.expanded.includes(name) && state.expanded.push(name)
    },
    collapse(state, name) {
      if (state.expanded.includes(name)) state.expanded = state.expanded.filter(val => val !== name)
    },
    saveParent(state, parent) {
      state.parents.push(parent)
    },
    saveRoute(state, route) {
      state.routes.push(route)
    },
    updateFilter(state, needle) {
      state.filter = needle
    },
  },
}
